const { onlyNumericNormalize, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Taiwan',
  code: 'TW',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{3,5}/),
      // validationRegex: new RegExp(zipCodeRegexNumeric(3)),
      error: 'Must be 3-5 digitis'
    }
  ]
};
